import { Button, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { isValidElement } from "react";

export function PillButton({ leftLabel, rightLabel, to, onClick, ...props }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    if (onClick) {
      onClick(e);
    }
    if (to) {
      navigate(to);
    }
  };

  return (
    <Button
      variant="light"
      radius="sm"
      size="xs"
      justify="space-between"
      fullWidth={!(isValidElement(leftLabel) || isValidElement(rightLabel))}
      leftSection={isValidElement(leftLabel) ? leftLabel : <Text size="xs">{leftLabel}</Text>}
      rightSection={
        rightLabel &&
        (isValidElement(rightLabel) ? (
          rightLabel
        ) : (
          <Text size="xs" c="dimmed">
            {rightLabel}
          </Text>
        ))
      }
      onClick={handleClick}
      sx={(theme) => ({
        padding: "4px 8px",
        transition: "all 150ms ease",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: theme.shadows.sm,
        },
        ...(isValidElement(leftLabel) || isValidElement(rightLabel)
          ? {
              "& .mantine-Button-section": {
                "& *": {
                  color: "inherit !important",
                },
              },
            }
          : {}),
        ...props.style,
      })}
      {...props}
    />
  );
}

export default PillButton;
